// extracted by mini-css-extract-plugin
export default {"footer":"layout_footer__HAwK7","inner":"layout_inner__20dG9","info":"layout_info__V1-Ll","logo":"layout_logo__JfepP"};